// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.unknown-platform-modal_modal-content_zdXL0 {
  max-width: 480px;
  margin-top: 50px;
}

.unknown-platform-modal_body_Wh_dp {
  background: var(--ui-modal-background);
  padding: 1.5rem 2.25rem;
  max-height: calc(100vh - 150px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.unknown-platform-modal_details_ppEE0 {
  font-family: monospace;
  -webkit-user-select: text;
     -moz-user-select: text;
      -ms-user-select: text;
          user-select: text;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.unknown-platform-modal_details_ppEE0::before,
.unknown-platform-modal_details_ppEE0::after {
  content: '"';
}

.unknown-platform-modal_button_J02D2 {
  font: inherit;
  font-weight: bold;
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid var(--ui-black-transparent);
  background-color: var(--looks-secondary);
  color: white;
}

.unknown-platform-modal_button_J02D2:disabled {
  opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-unknown-platform-modal/unknown-platform-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,6CAA6C;EAC7C,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  max-width: 480px;\n  margin-top: 50px;\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 1.5rem 2.25rem;\n  max-height: calc(100vh - 150px);\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.details {\n  font-family: monospace;\n  -webkit-user-select: text;\n     -moz-user-select: text;\n      -ms-user-select: text;\n          user-select: text;\n  text-wrap: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.details::before,\n.details::after {\n  content: '\"';\n}\n\n.button {\n  font: inherit;\n  font-weight: bold;\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  border: 1px solid var(--ui-black-transparent);\n  background-color: var(--looks-secondary);\n  color: white;\n}\n\n.button:disabled {\n  opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `unknown-platform-modal_modal-content_zdXL0`,
	"modalContent": `unknown-platform-modal_modal-content_zdXL0`,
	"body": `unknown-platform-modal_body_Wh_dp`,
	"details": `unknown-platform-modal_details_ppEE0`,
	"button": `unknown-platform-modal_button_J02D2`
};
export default ___CSS_LOADER_EXPORT___;
